import { render, staticRenderFns } from "./calendar-week.vue?vue&type=template&id=6165a9c5&"
import script from "./calendar-week.vue?vue&type=script&lang=ts&"
export * from "./calendar-week.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6165a9c5')) {
      api.createRecord('6165a9c5', component.options)
    } else {
      api.reload('6165a9c5', component.options)
    }
    module.hot.accept("./calendar-week.vue?vue&type=template&id=6165a9c5&", function () {
      api.rerender('6165a9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/calendar-week.vue"
export default component.exports